import { render, staticRenderFns } from "./PDCRequestV2.vue?vue&type=template&id=5f005691&"
import script from "./PDCRequestV2.vue?vue&type=script&lang=js&"
export * from "./PDCRequestV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports